module.exports = __webpack_public_path__ + "imgs/fox_logo.6aedb029.png";